import { OpenBlank } from "@payping/icons";
import { Card, Flex, Image, Typography, usePaypingContext } from "@payping/web-components";
import { Link } from "react-router-dom";
import { useAppTranslation } from "@/utils";
import classNames from "classnames";
import { featuredPluginsList } from "./data";

interface ItemProps {
  data: (typeof featuredPluginsList)[keyof typeof featuredPluginsList];
  googleTrackId?: string;
}
const FeaturedItem = (props: ItemProps) => {
  const { t } = useAppTranslation();
  const { breakpoints } = usePaypingContext();
  const { xs } = breakpoints;
  return (
    <Link
      to={props.data.pathName || ""}
      className={classNames([{ "tw:w-full": xs }])}
      data-google-track={props.googleTrackId}
    >
      <Card role="button" classNames={{ body: "tw:p-4!" }}>
        <Flex gap="0.5rem">
          <Image preview={false} src={props.data.logo} width={54} height={54} className="tw:min-w-13.5!" />
          <Flex gap="0.5rem" vertical className="tw:w-full">
            <Flex align="center" className="tw:w-full">
              <Flex gap="0.5rem" vertical={xs}>
                <Typography.Title className="tw:m-0!" level={5}>
                  {t(`connections.plugins.featuredList.${props.data.translationKey}.title`)}
                </Typography.Title>
                {props.data.subTitle ? (
                  <Typography.Text className="color--gray500 tw:m-0!">
                    {t(`connections.plugins.featuredList.${props.data.translationKey}.subTitle`)}
                  </Typography.Text>
                ) : null}
              </Flex>
              <div className="tw:mr-auto tw:self-start tw:pr-4!">
                <OpenBlank width={"16px"} />
              </div>
            </Flex>
            <Typography.Paragraph className="color--gray500 tw:m-0!">
              {t(`connections.plugins.featuredList.${props.data.translationKey}.description`)}
            </Typography.Paragraph>
          </Flex>
        </Flex>
      </Card>
    </Link>
  );
};

export default FeaturedItem;
